import { createGlobalStyle } from 'styled-components';

const ToastifyStyle = createGlobalStyle<any>`
  .Toastify__toast-container {
    font-size: 16px;
  }
  .Toastify__toast {
    border-radius: 4px;
    box-shadow: 2px 2px 20px 2px rgba(0,0,0,0.3);
  }
  .Toastify__toast-body {
    padding: 8px 12px;
  }
  .Toastify__toast--default {
    background: ${({ theme: { colors } }) => colors.light.stain};
    color: ${({ theme: { colors } }) => colors.dark.stain};
  }
  .Toastify__toast--info {
    background: ${({ theme: { colors } }) => colors.secondary.stain};
  }
  .Toastify__toast--success {
    background: ${({ theme: { colors } }) => colors.success.stain};
  }
  .Toastify__toast--warning {
    background: ${({ theme: { colors } }) => colors.warning.stain};
  }
  .Toastify__toast--error {
    background: ${({ theme: { colors } }) => colors.danger.stain};
  }
`;
export default ToastifyStyle;
